import { render, staticRenderFns } from "./InputUrl.vue?vue&type=template&id=38b975d0&scoped=true&"
import script from "./InputUrl.vue?vue&type=script&lang=js&"
export * from "./InputUrl.vue?vue&type=script&lang=js&"
import style0 from "./InputUrl.vue?vue&type=style&index=0&id=38b975d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b975d0",
  null
  
)

export default component.exports